// Shared numerical model: browser previews and the server use the same geometry.
const KINDS=new Set(['Trend Line','Ray','Extended Line','Horizontal Line','Horizontal Ray','Parallel Channel','Fib Retracement','Fib Extension']);
function normalizeDrawing(value){
 if(value==null)return null;
 if(!value||value.version!==1||!KINDS.has(value.kind)||!Array.isArray(value.points))throw new Error('Unsupported drawing alert.');
 const points=value.points.map(p=>{if(!Array.isArray(p)||p.length!==2||!p.every(Number.isFinite)||p[0]<0||p[1]<=0)throw new Error('Drawing anchors must contain valid timestamps and prices.');return p.slice()});
 const required=['Parallel Channel','Fib Extension'].includes(value.kind)?3:value.kind.startsWith('Horizontal')?1:2;
 if(points.length!==required)throw new Error('Incomplete drawing anchors.');
 if(required>1&&points[0][0]===points[1][0])throw new Error('Vertical drawings cannot evaluate a price alert.');
 const level=value.level===undefined ? .618 : Number(value.level);if(!Number.isFinite(level)||Math.abs(level)>100)throw new Error('Invalid Fibonacci alert level.');
 return {version:1,uuid:String(value.uuid || '').slice(0,160),kind:value.kind,points,level,log:!!value.log,reverse:!!value.reverse,extendLeft:!!value.extendLeft,extendRight:!!value.extendRight};
}
function drawingBounds(d,time){
 const [a,b,c]=d.points,transform=x=>d.log?Math.log(x):x,undo=x=>d.log?Math.exp(x):x;
 if(d.kind==='Fib Retracement'||d.kind==='Fib Extension'){
  const delta=transform(b[1])-transform(a[1]),extension=d.kind==='Fib Extension';
  const price=undo(transform(extension?c[1]:b[1])+delta*d.level*(extension?1:-1)*(d.reverse?-1:1));return [price,price];
 }
 if(d.kind.startsWith('Horizontal'))return [a[1],a[1]];
 const slope=(transform(b[1])-transform(a[1]))/(b[0]-a[0]);
 const at=t=>transform(a[1])+(t-a[0])*slope;
 const first=undo(at(time));
 if(d.kind!=='Parallel Channel')return [first,first];
 const second=undo(at(time)+transform(c[1])-at(c[0]));return [Math.min(first,second),Math.max(first,second)];
}
function drawingActive(d,time){
 if(d.kind.startsWith('Fib')||d.kind==='Extended Line')return true;
 if(d.kind==='Horizontal Line')return true;
 const [a,b]=d.points;
 if(d.kind==='Horizontal Ray')return time>=a[0]||d.extendLeft;
 const min=Math.min(a[0],b[0]),max=Math.max(a[0],b[0]);
 if(d.kind==='Ray')return b[0]>=a[0]?time>=a[0]||d.extendLeft:time<=a[0]||d.extendRight;
 return (time>=min||d.extendLeft)&&(time<=max||d.extendRight);
}
function drawingCondition(condition,drawing,previous,current){
 if(!current||!Number.isFinite(current.price)||!drawingActive(drawing,current.time))return false;
 const [lo,hi]=drawingBounds(drawing,current.time);if(!Number.isFinite(lo)||!Number.isFinite(hi))return false;
 const inside=current.price>=lo&&current.price<=hi;
 if(condition==='inside')return inside;if(condition==='outside')return !inside;
 if(condition==='above')return current.price>hi;if(condition==='below')return current.price<lo;
 if(!previous||!Number.isFinite(previous.price)||!drawingActive(drawing,previous.time))return false;
 const [pl,ph]=drawingBounds(drawing,previous.time),wasInside=previous.price>=pl&&previous.price<=ph;
 if(condition==='entering')return !wasInside&&inside;if(condition==='exiting')return wasInside&&!inside;
 const up=previous.price<=ph&&current.price>hi,down=previous.price>=pl&&current.price<lo;
 return condition==='crossing_up'?up:condition==='crossing_down'?down:condition==='crossing'?up||down:false;
}
module.exports={normalizeDrawing,drawingBounds,drawingCondition,drawingActive};
